import { isRequired, maxLength } from 'utils/validate/validate';

export const validationsCreateUpdate = dadosInputs => {
  const { nomeServico, descricaoServico, documentos, identificadorServico, situacaoId } = dadosInputs;
  const errosCampos = {
    nomeServico: null,
    descricaoServico: null,
    documentos: null,
    identificadorServico: null,
    situacaoId: null,
  };

  errosCampos.nomeServico = isRequired(nomeServico);
  errosCampos.descricaoServico = isRequired(descricaoServico);
  errosCampos.documentos = isRequired(documentos) || maxLength(documentos, 4000);
  errosCampos.identificadorServico = isRequired(identificadorServico);
  errosCampos.situacaoId = isRequired(situacaoId);
  return errosCampos;
};
